<script>
  import { onMount, tick } from 'svelte';
  import { initializeApp } from "firebase/app";
  import { getDatabase, ref, onChildAdded, push, serverTimestamp, query, limitToLast } from "firebase/database";
  import { notes } from './data/notes.js';
  import Notes from './Notes.svelte';
  import NoteDetail from './NoteDetail.svelte';

  // -- SVELTE 5 RECENT STATE RUNES --
  let isTabTwo = $state(false);
  let currentView = $state('home'); // 'home' | 'notes' | 'note-detail'
  let selectedNoteId = $state('');

  let latestNotes = $derived(notes.slice(0, 2));

  function parseHash() {
    const hash = window.location.hash || '#/';
    if (hash.startsWith('#/notes/')) {
      currentView = 'note-detail';
      selectedNoteId = hash.replace('#/notes/', '');
    } else if (hash === '#/notes' || hash === '#notes') {
      currentView = 'notes';
      selectedNoteId = '';
    } else {
      currentView = 'home';
      selectedNoteId = '';
    }
    window.scrollTo(0, 0);
  }

  function navigateTo(view, slug = '') {
    if (view === 'notes') {
      window.location.hash = '#/notes';
    } else if (view === 'note-detail' && slug) {
      window.location.hash = `#/notes/${slug}`;
    } else {
      window.location.hash = '#/';
    }
    window.scrollTo(0, 0);
  }

  $effect(() => {
    if (currentView || selectedNoteId) {
      window.scrollTo(0, 0);
    }
  });

  // -- FIREBASE SETUP --
  const firebaseConfig = {
    apiKey: "AIzaSyDJaIq4pAy_oJY0p8_zmfO_ZZ0v4AhqxKw",
    authDomain: "manabesu-githubio.firebaseapp.com",
    databaseURL: "https://manabesu-githubio-default-rtdb.firebaseio.com",
    projectId: "manabesu-githubio",
    storageBucket: "manabesu-githubio.firebasestorage.app",
    messagingSenderId: "1088701237489",
    appId: "1:1088701237489:web:83fd17418ad5f67ca50150",
    measurementId: "G-PWB2N9WYW6"
  };

  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);
  
  const writeRef = ref(db, 'public_chat');
  const readQuery = query(writeRef, limitToLast(50));

  // -- CHAT COMPONENT STATE --
  let messages = $state([]);
  let chatName = $state('');
  let currentMessage = $state('');
  let chatContainer = $state(null); // Reference for auto-scrolling

  // -- LIFECYCLE --
  onMount(() => {
    parseHash();
    const handleHashChange = () => parseHash();
    window.addEventListener('hashchange', handleHashChange);

    // Listen for DB additions
    onChildAdded(readQuery, async (snapshot) => {
      const data = snapshot.val() || {};
      if (!data.text) return;

      messages = [...messages, { name: data.name || 'Anonymous', text: data.text }];
      
      await tick();
      if (chatContainer) chatContainer.scrollTop = chatContainer.scrollHeight;
    });

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  });

  function sendMessage() {
    const text = currentMessage.trim().substring(0, 500);
    const name = chatName.trim().substring(0, 30) || "Anonymous";

    if (!text) return;

    push(writeRef, {
      name,
      text,
      timestamp: serverTimestamp()
    }).catch(err => console.error("Firebase write rejected:", err));

    currentMessage = '';
  }
</script>

<div class="app-wrapper">
  <!-- TOP NAVIGATION BAR -->
  <header class="top-navbar">
    <button class="nav-brand" onclick={() => navigateTo('home')}>
      Manabesu
    </button>
    
    <nav class="nav-links">
      <button 
        class="nav-item {currentView === 'home' ? 'active' : ''}" 
        onclick={() => navigateTo('home')}
      >
        Home
      </button>
      <button 
        class="nav-item {currentView !== 'home' ? 'active' : ''}" 
        onclick={() => navigateTo('notes')}
      >
        Notes <span class="nav-badge">{notes.length}</span>
      </button>
    </nav>
  </header>

  {#if currentView === 'home'}
    <main>
      <aside class="panel left">
        <img class="avatar" src="tako.png" alt="profile pic">
        <h1>Hello Manab</h1>
        <span class="pronouns">sin/cos • 20 y/o • CSE</span>
        <p class="bio">He's a Computer Science student and a big dummy overthinker</p>
        
        <div class="links">
          <a href="https://discord.com/users/okaymango5"><img src="https://s.magecdn.com/social/16w/mw-discord.png" alt="discord"></a>
          <a href="https://github.com/Manabesu/"><img src="https://s.magecdn.com/social/16w/mw-github.png" alt="github"></a>
          <a href="https://www.linkedin.com/in/manabesu/"><img src="https://s.magecdn.com/social/16w/mw-linkedin.png" alt="linkedin"></a>
          <a href="https://medium.com/@manabesu"><img src="https://s.magecdn.com/social/mw-medium.svg" alt="Articles" style="transform: scale(0.8);"></a>
          <a href="mailto:mmmanabendra2006@gmail.com"><img src="https://s.magecdn.com/social/16w/mw-mail.png" alt="email"></a>
        </div>
      </aside>

      <section class="panel right">
        <header class="tab-header">
          <button 
            class="slide-switch {isTabTwo ? 'active' : ''}" 
            onclick={() => isTabTwo = !isTabTwo}
            aria-label="Toggle view"
          >
            <span class="slide-knob"></span>
          </button>
        </header>

        {#key isTabTwo}
          <article class="content">
            {#if !isTabTwo}
          <p>
          A 2nd year CSE student at SOA Uni.
          </p>
          <p>
          Currently exploring what lies ahead of him. For that, he's dabbling in a lot of things,
          from programming to music to quantum mechanics.
          </p>
          <p>
            Looking for all opportunities to learn various stuff.
          </p>
          <p>
            He doesn't have many friends. If you'd like to be one, please reach him out. 
            He may not communicate with you much, but he doesn't mean anything bad.
          </p>
          {:else}
            <div class="interest-list">
              <div>
                  <ul style="margin-top: 0;">
                    <h3 style="margin:0;">ANIME/MANGA</h3>
                    <li>Tensura</li>
                    <li>Mairimashita! Iruma-kun</li>
                    <li>Hyouka</li>
                    <li>The Apothecary Diaries</li>
                    <li>Tanaka-kun</li>
                    <li>Bocchi the Rock!</li>
                    <li>Mushishi</li>
                    <li>No Game No Life</li>
                    <li>Lord of Mysteries</li>
                  </ul>
              </div>
              <div>
                  <ul style="margin-top: 0;">
                    <h3 style="margin:0;">GAMES</h3>
                    <li>Hollow Knight</li>
                    <li>Osu!</li>
                    <li>Holocure</li>
                    <li>Pokemon</li>
                    <li>AFK Journey</li>
                    <li>Minecraft</li>
                    <li>Stardew Valley</li>
                  </ul>
              </div>
                <div>
                  <ul style="margin-top: 0;">
                    <h3 style="margin:0;">OTHERS</h3>
                    <li>Vtubers</li>
                    <li>Mysteries</li>
                    <li>Japanese</li>
                    <li>Novels</li>
                    <li>Listening to Songs</li>
                    <li>Mechatronics</li>
                    <li>Quantum Physics</li>
                    <li>Programming stuff</li>
                  </ul>
              </div>
            </div>
            
          {/if}
        </article>
        {/key}
      </section>

      <!-- LATEST NOTES SECTION -->
      <section class="panel notes-section">
        <div class="section-header">
          <h2>Latest Notes</h2>
          <button class="view-all-btn" onclick={() => navigateTo('notes')}>
            View all ({notes.length}) →
          </button>
        </div>

        <div class="latest-notes-grid">
          {#each latestNotes as note (note.id)}
            <div 
              class="latest-note-card" 
              role="button" 
              tabindex="0" 
              onclick={() => navigateTo('note-detail', note.id)}
              onkeydown={(e) => (e.key === 'Enter' || e.key === ' ') && navigateTo('note-detail', note.id)}
            >
              <div class="card-meta">
                <span class="date">{note.date}</span>
                <span class="dot">•</span>
                <span class="read-time">{note.readTime}</span>
              </div>
              <h3 class="card-title">{note.title}</h3>
              <p class="card-summary">{note.summary}</p>
              <div class="card-footer">
                <span class="read-link">Read Note →</span>
              </div>
            </div>
          {/each}
        </div>
      </section>

      <section class="panel chat-section">
        <h2>Public Room</h2>
        <div class="chat-container">
          <div class="chat-messages">
            {#each messages as msg}
            <div class="" bind:this={chatContainer}>
              <div class="message">
              <strong class="user">{msg.name}:</strong> {msg.text}
              </div>
            {#if messages.length === 0}
              <p class="empty">Loading messages...</p>
            {/if}
            </div>
            {/each}
            {#if messages.length === 0}
              <p class="empty">No messages yet. Be the first.</p>
            {/if}
          </div>
          
          <div class="chat-inputs">
            <input type="text" bind:value={chatName} placeholder="Name" class="theme-input name-input" />
            <input 
              type="text" 
              bind:value={currentMessage} 
              placeholder="Type a message..." 
              class="theme-input msg-input" 
              onkeydown={(e) => e.key === 'Enter' && sendMessage()} 
            />
            <button onclick={sendMessage} class="theme-button">Send</button>
          </div>
        </div>
      </section>
    </main>
  {:else if currentView === 'notes'}
    <Notes 
      selectNote={(id) => navigateTo('note-detail', id)} 
      navigate={navigateTo} 
    />
  {:else if currentView === 'note-detail'}
    <NoteDetail 
      noteId={selectedNoteId} 
      selectNote={(id) => navigateTo('note-detail', id)} 
      navigate={navigateTo} 
    />
  {/if}
</div>



<style>
  :global(body) {
    margin: 0;
    padding: clamp(1rem, 3vw, 3rem);
    color: #e0e0e0;
    font-family: "Cause", "Segoe UI", Roboto, sans-serif;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .app-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;
    gap: 1.5rem;
  }

  /* -- TOP NAVBAR -- */
  .top-navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #000000;
    border: 1px solid #ffffff;
    border-radius: clamp(16px, 2vw, 32px);
    padding: 0.8rem 1.5rem;
    box-sizing: border-box;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .nav-brand {
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #ffffff;
    cursor: pointer;
    background: transparent;
    border: none;
    font-family: inherit;
    padding: 0;
    margin: 0 !important;
    transition: opacity 0.2s;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }

  .nav-brand:hover {
    opacity: 0.8;
  }

  .nav-links {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
  }

  .nav-item {
    background: transparent;
    border: 1px solid transparent;
    color: #888;
    padding: 0.4rem 1rem;
    margin: 0 !important;
    border-radius: 20px;
    font-size: 0.95rem;
    font-family: inherit;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    gap: 0.4rem;
  }

  .nav-item:hover {
    color: #ffffff;
    border-color: #444;
  }

  .nav-item.active {
    color: #000000;
    background: #ffffff;
    border-color: #ffffff;
    font-weight: 600;
  }

  .nav-badge {
    font-size: 0.75rem;
    background: #222;
    color: #fff;
    padding: 0.15rem 0.45rem;
    border-radius: 10px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
  }

  .nav-item.active .nav-badge {
    background: #000;
    color: #fff;
  }

  main {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) minmax(320px, 2.5fr);
    gap: clamp(1rem, 2vw, 2rem);
    width: 100%;
  }

  @media (max-width: 768px) {
    main { grid-template-columns: 1fr; }
  }

  .panel {
    background: #000000;
    border: 1px solid #ffffff;
    border-radius: clamp(16px, 2vw, 32px);
    padding: clamp(1.5rem, 3vw, 3rem);
  }

  /* -- LATEST NOTES SECTION -- */
  .notes-section {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-header h2 {
    margin: 0;
    font-size: clamp(1.2rem, 2vw, 1.5rem);
    font-weight: 600;
  }

  .view-all-btn {
    background: transparent;
    border: 1px solid #333;
    color: #e0e0e0;
    padding: 0.4rem 0.9rem;
    border-radius: 20px;
    font-size: 0.85rem;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .view-all-btn:hover {
    border-color: #ffffff;
    color: #ffffff;
    background: #111;
  }

  .latest-notes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.25rem;
  }

  .latest-note-card {
    background: #050505;
    border: 1px solid #222;
    border-radius: clamp(12px, 1.5vw, 20px);
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease;
  }

  .latest-note-card:hover {
    transform: translateY(-3px);
    border-color: #ffffff;
  }

  .card-meta {
    font-size: 0.8rem;
    color: #888;
    margin-bottom: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .card-title {
    margin: 0 0 0.5rem 0;
    font-size: 1.15rem;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.35;
  }

  .card-summary {
    font-size: 0.9rem;
    color: #aaa;
    line-height: 1.5;
    margin: 0 0 1.25rem 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    padding-top: 0.75rem;
    border-top: 1px solid #1a1a1a;
  }



  .read-link {
    font-size: 0.8rem;
    color: #ffffff;
    font-weight: 600;
  }

  .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .avatar {
    width: clamp(80px, 15vw, 120px);
    height: clamp(80px, 15vw, 120px);
	transform: scaleX(-1);
  }

  .interest-list{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: clamp(1rem, 2vw, 1.5rem);
    margin-top: 0.5rem;
  }

  h1 {
    font-size: clamp(1.5rem, 2.5vw, 2rem);
    margin: 0 0 0.25rem 0;
    font-weight: 600;
  }

  .pronouns {
    font-size: clamp(0.75rem, 1vw, 0.9rem);
    color: #888;
    letter-spacing: 1px;
    margin-bottom: 1.5rem;
  }

  .bio {
    font-size: clamp(0.9rem, 1.2vw, 1rem);
    line-height: 1.6;
    color: #bbb;
    margin-bottom: 2rem;
  }

  .links {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.25rem;
    flex-wrap: wrap;
    margin-top: auto;
    padding-top: 1rem;
  }

  .links a {
    color: #e0e0e0;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s, transform 0.2s ease;
  }

  .links a:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }

  .right {
    display: flex;
    flex-direction: column;
  }

  .tab-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 1.5rem;
  }

  .slide-switch {
    position: relative;
    width: 48px;
    height: 24px;
    background: #0d0d0d;
    border: 1px solid #333333;
    border-radius: 24px;
    padding: 2px;
    margin: 0 !important;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    box-sizing: border-box;
    outline: none;
  }

  .slide-switch:hover {
    border-color: #666666;
  }

  .slide-switch.active {
    background: #1a1a1a;
    border-color: #ffffff;
  }

  .slide-knob {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }

  .slide-switch.active .slide-knob {
    transform: translateX(22px);
  }

  .content {
    font-size: clamp(1rem, 1.5vw, 1.1rem);
    line-height: 1.7;
    color: #ccc;
    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }

  @keyframes slideIn {
    from { opacity: 0; transform: translateX(10px); }
    to { opacity: 1; transform: translateX(0); }
  }

  p { margin-top: 0; }
  ul { padding-left: 1.5rem; }


  /* -- CHAT SECTION -- */
.chat-section {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.chat-section h2 {
  margin: 0;
  font-size: clamp(1.2rem, 2vw, 1.5rem);
  font-weight: 600;
}

.chat-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.chat-messages {
  height: clamp(250px, 40vh, 400px); /* Responsive vertical constraint */
  background: #121212;
  border-radius: clamp(8px, 1vw, 12px);
  padding: 1rem;
  overflow-y: auto;
  border: 1px solid #333;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Minimal Custom Scrollbar for the chat */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}
.chat-messages::-webkit-scrollbar-track {
  background: transparent;
}
.chat-messages::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 6px;
}
.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.message {
  line-height: 1.5;
  font-size: clamp(0.9rem, 1.2vw, 1rem);
  word-wrap: break-word;
}

.user {
  color: #fff;
  font-weight: 600;
}

.empty {
  color: #666;
  font-style: italic;
  text-align: center;
  margin: auto;
}

.chat-inputs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap; /* Prevents input crushing on mobile */
}

.theme-input, .theme-button {
  background: #121212;
  border: 1px solid #333;
  color: #e0e0e0;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-family: inherit;
  font-size: clamp(0.9rem, 1.2vw, 1rem);
  transition: border-color 0.2s, opacity 0.2s;
}

.theme-input:focus {
  outline: none;
  border-color: #e0e0e0; /* High contrast focus state */
}

.name-input {
  flex: 1;
  min-width: 100px;
}

.msg-input {
  flex: 3;
  min-width: 200px;
}

.theme-button {
  background: #e0e0e0;
  color: #000;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.theme-button:hover {
  opacity: 0.8;
}
</style>